<app-selector
  label="Straight Shooter Game"
  [isEmptySelectable]="isEmptySelectable"
  [data]="straightShooterGameCoreService.straightShooterGameList$ | async"
  displayKey="name"
  [formControl]="ctrl"
  (refreshEvent)="refresh()"
  hintStyle="margin-left: -14px; margin-top: -5px"
  [loading]="straightShooterGameCoreService.loading$ | async"
  [hint]="hint"
>
</app-selector>
